import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from "@ngrx/data";
import {InsoleElementDefinitionRepository} from "./impl/service/ngrx/insoleElementDefinition.repository";
import {InsoleElementDefinitionDataService} from "./impl/service/ngrx/insoleElementDefinitionData.service";
@NgModule()
export class InsoleElementDefinitionModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: InsoleElementDefinitionRepository,
                 dataService: InsoleElementDefinitionDataService,
    ) {

        entityDataService.registerServices({
            InsoleElementDefinition: dataService,
        });

        entityServices.registerEntityCollectionServices({
            InsoleElementDefinition: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
